import { BooleanValueProperty } from './boolean-property.model';
import { TextProperty } from './text-property.model';

export class FormConfigProperties {
  public title: TextProperty;
  public showHeader: BooleanValueProperty;
  public showFooter: BooleanValueProperty;
  public header: TextProperty;
  public footer: TextProperty;
  public pageNumbers: BooleanValueProperty;

  constructor(data: any = {}) {
    this.title = data.title || new TextProperty();
    this.showHeader =
      new BooleanValueProperty(data.showHeader) ||
      new BooleanValueProperty({ title: 'Header', value: false });
    this.showFooter =
      new BooleanValueProperty(data.showFooter) || new BooleanValueProperty({ title: 'Footer' });
    this.header = data.header || new TextProperty({ title: 'html' }); // WARNING: Must be HtmlProperty
    this.footer = new TextProperty(data.footer) || new TextProperty({ title: 'html' }); // WARNING: Must be HtmlProperty
    this.pageNumbers = data.pageNumbers || new BooleanValueProperty({ title: 'Page numbers' });
  }
}
